// Section for import npm components -----------------------------------------------------------------------------------
import React, { useContext } from 'react';

// Material UI ( mui )  components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

// Section for import custom components --------------------------------------------------------------------------------
import { AppConfigContext } from '@providers/AppConfigProvider';
import RentHistoryList from '@components/MansionDetail/RentHistory/RentHistoryList';
import RentHistoryListSp from '@components/MansionDetail/RentHistory/SP/RentHistoryList';

// Section for type definition -----------------------------------------------------------------------------------------
// import CommonUtilityClass from '@/types/CommonUtilityClass';
import RentHistoryPropsData from '@/types/components/MansionDetail/RentHistoryPropsData';

type RentHistoryProps = {
  rentHistory: RentHistoryPropsData;
};

export default function RentHistory(props: RentHistoryProps): React.JSX.Element {
  const { isMobile } = useContext(AppConfigContext);
  const { rentHistory } = props;
  const rentHistoryContent =
    rentHistory && Array.isArray(rentHistory) && rentHistory.length > 0 ? (
      <Box id="section-rent-history">
        <Box className="md:max-w-7xl w-full mx-auto px-24 max-md:px-5 md:mb-16 max-md:mb-12">
          {isMobile ? <RentHistoryListSp rentHistory={rentHistory} /> : <RentHistoryList rentHistory={rentHistory} />}
          <Box className="rf-mansion-review">
            <Typography className="text-2xs mr-1">※</Typography>
            <Typography className="text-2xs">
              賃料履歴は
              <Link
                href="https://www.mansion-review.jp/"
                underline="none"
                className="text-rf-blue font-bold underline"
                target="_blank"
              >
                マンションレビュー
              </Link>
              の提供により掲載しております。表示価格は成約価格ではなく、賃貸募集時の価格となります。
            </Typography>
          </Box>
        </Box>
      </Box>
    ) : null;

  return <Box>{rentHistoryContent}</Box>;
}
